// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IntegrationClientsTypeahead_IntegrationClientFragment = { __typename?: 'IntegrationClient', id: string, integrationID: string, name: string, externalKind?: Types.IntegrationClientExternalKind | null, kind: Types.IntegrationClientKind };

export type GetIntegrationClientsMultipleQueryVariables = Types.Exact<{
  optionsLike?: Types.InputMaybe<Types.IntegrationClientWhereInput>;
  selectedOptionsLike?: Types.InputMaybe<Types.IntegrationClientWhereInput>;
  first: Types.Scalars['Int']['input'];
}>;


export type GetIntegrationClientsMultipleQuery = { __typename?: 'Query', queryData: { __typename?: 'IntegrationClientConnection', totalCount: number, edges?: Array<{ __typename?: 'IntegrationClientEdge', node?: (
        { __typename?: 'IntegrationClient' }
        & IntegrationClientsTypeahead_IntegrationClientFragment
      ) | null } | null> | null }, selectedData: { __typename?: 'IntegrationClientConnection', totalCount: number, edges?: Array<{ __typename?: 'IntegrationClientEdge', node?: (
        { __typename?: 'IntegrationClient' }
        & IntegrationClientsTypeahead_IntegrationClientFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    GetIntegrationClientsMultiple: 'GetIntegrationClientsMultiple' as const
  },
  Fragment: {
    IntegrationClientsTypeahead_IntegrationClient: 'IntegrationClientsTypeahead_IntegrationClient' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const IntegrationClientsTypeahead_IntegrationClientFragmentDoc = gql`
    fragment IntegrationClientsTypeahead_IntegrationClient on IntegrationClient {
  id
  integrationID
  name
  externalKind
  kind
}
    `;
export const GetIntegrationClientsMultipleDocument = gql`
    query GetIntegrationClientsMultiple($optionsLike: IntegrationClientWhereInput, $selectedOptionsLike: IntegrationClientWhereInput, $first: Int!) {
  queryData: integrationClients(
    where: $optionsLike
    first: $first
    orderBy: [{direction: ASC, field: name}]
  ) {
    totalCount
    edges {
      node {
        ...IntegrationClientsTypeahead_IntegrationClient
      }
    }
  }
  selectedData: integrationClients(where: $selectedOptionsLike) {
    totalCount
    edges {
      node {
        ...IntegrationClientsTypeahead_IntegrationClient
      }
    }
  }
}
    ${IntegrationClientsTypeahead_IntegrationClientFragmentDoc}`;

/**
 * __useGetIntegrationClientsMultipleQuery__
 *
 * To run a query within a React component, call `useGetIntegrationClientsMultipleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationClientsMultipleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationClientsMultipleQuery({
 *   variables: {
 *      optionsLike: // value for 'optionsLike'
 *      selectedOptionsLike: // value for 'selectedOptionsLike'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetIntegrationClientsMultipleQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationClientsMultipleQuery, GetIntegrationClientsMultipleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationClientsMultipleQuery, GetIntegrationClientsMultipleQueryVariables>(GetIntegrationClientsMultipleDocument, withFetchPolicyContext(options));
      }
export function useGetIntegrationClientsMultipleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationClientsMultipleQuery, GetIntegrationClientsMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationClientsMultipleQuery, GetIntegrationClientsMultipleQueryVariables>(GetIntegrationClientsMultipleDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetIntegrationClientsMultipleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationClientsMultipleQuery, GetIntegrationClientsMultipleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationClientsMultipleQuery, GetIntegrationClientsMultipleQueryVariables>(GetIntegrationClientsMultipleDocument, withFetchPolicyContext(options));
        }
export type GetIntegrationClientsMultipleQueryHookResult = ReturnType<typeof useGetIntegrationClientsMultipleQuery>;
export type GetIntegrationClientsMultipleLazyQueryHookResult = ReturnType<typeof useGetIntegrationClientsMultipleLazyQuery>;
export type GetIntegrationClientsMultipleSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationClientsMultipleSuspenseQuery>;
export type GetIntegrationClientsMultipleQueryResult = Apollo.QueryResult<GetIntegrationClientsMultipleQuery, GetIntegrationClientsMultipleQueryVariables>;